'use client';

import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { useCurrentMarketStepDecimal } from 'src/hooks/useMarketStepSize';
import { useTradeFormSyncSizeValues } from './useTradeFormSyncSizeValues';
import { useSyncResetTradeForm } from './useSyncResetTradeForm';
import { useSyncTradeFormOnOrderTypeChange } from './useSyncTradeFormOnOrderTypeChange';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import { useShallow } from 'zustand/react/shallow';
import { UIMarket } from '@velocity-exchange/common';
import {
	useLiveMarkPrice,
	useLiveOraclePrice,
} from 'src/stores/marketLiveState';

const useTradeFormInputStateEngine = () => {
	const selectedMarket = useVelocityStore((s) => s.selectedMarket.current);
	const selectedMarketId = useVelocityStore((s) => s.selectedMarket.marketId);
	const step = useCurrentMarketStepDecimal();
	const markPrice = useLiveMarkPrice(selectedMarketId);
	const oraclePrice = useLiveOraclePrice(selectedMarketId)?.price;

	const {
		tradeSide,
		leadSide,
		quoteSizeStringValue,
		baseSizeStringValue,
		priceBoxStringValue,
		secondaryPriceBoxStringValue,
		orderType,
	} = useVelocityStore(
		useShallow((s) => ({
			tradeSide: s.tradeForm.side,
			quoteSizeStringValue: s.tradeForm.quoteSizeStringValue,
			baseSizeStringValue: s.tradeForm.baseSizeStringValue,
			priceBoxStringValue: s.tradeForm.priceBoxStringValue,
			secondaryPriceBoxStringValue: s.tradeForm.secondaryPriceBoxStringValue,
			leadSide: s.tradeForm.leadSide,
			orderType: s.tradeForm.orderType,
		}))
	);

	const currentPosition = useVelocityAccountStore((s) =>
		s
			.getCurrentUserAccount()
			?.client?.getUserAccount()
			?.perpPositions?.find(
				(pos) => pos.marketIndex === (selectedMarketId?.marketIndex as number)
			)
	);
	const currentUserAccountKey = useVelocityAccountStore(
		(s) => s.getCurrentUserAccount()?.userKey as string
	);

	useTradeFormSyncSizeValues({
		oraclePrice,
		markPrice,
		orderType,
		priceBoxStringValue,
		secondaryPriceBoxStringValue,
		leadSide,
		baseSizeStringValue,
		quoteSizeStringValue,
		step,
		tradeSide,
		currentPosition,
		selectedMarket: selectedMarket as UIMarket,
	});

	useSyncResetTradeForm(selectedMarketId?.key, currentUserAccountKey);

	useSyncTradeFormOnOrderTypeChange({
		orderType,
		baseSizeStringValue,
		quoteSizeStringValue,
	});
};

export default useTradeFormInputStateEngine;
